import React, { useCallback, useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import CarrierSetup, { CARRIER_SETUP_MSG } from "@/components/CarrierSetup";

export const isSetupError = (e) => e?.response?.status === 403 && String(e?.response?.data?.detail || "").startsWith(CARRIER_SETUP_MSG);

// Shown once, at the moment a carrier tries to accept/offer without finishing verification for that trip.
export const CarrierSetupDialog = ({ tripId, open, onClose }) => {
  const { user } = useAuth();
  const [missing, setMissing] = useState(null);
  const load = useCallback(() => {
    if (open) api.get("/verification/status", { params: { trip_id: tripId } }).then((r) => setMissing(r.data.carrier_missing)).catch(() => {});
  }, [open, tripId]);
  useEffect(() => { load(); }, [load, user]);
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-h-[85vh] overflow-y-auto" data-testid="carrier-setup-dialog">
        <DialogHeader>
          <DialogTitle>Finish verification to accept</DialogTitle>
          <DialogDescription>Each step is done once and never asked again.</DialogDescription>
        </DialogHeader>
        {missing && missing.length === 0
          ? <div className="text-sm text-emerald-700" data-testid="carrier-setup-complete">All set — you can accept now.</div>
          : <CarrierSetup missing={missing || []} compact/>}
      </DialogContent>
    </Dialog>
  );
};

export default CarrierSetupDialog;
